export type ItemCreationContext = 'eshop' | 'erp';

export const ITEM_CREATION_PATHS = {
  eshop: {
    create: '/eshop/dashboard/items/create',
    edit: '/eshop/dashboard/items/edit',
  },
  erp: {
    create: '/erp/services/catalogue/create',
    edit: '/erp/services/catalogue/edit',
  },
} as const satisfies Record<ItemCreationContext, { create: string; edit: string }>;

export const getItemCreatePath = (context: ItemCreationContext): string =>
  ITEM_CREATION_PATHS[context].create;

export const getItemEditPath = (context: ItemCreationContext): string =>
  ITEM_CREATION_PATHS[context].edit;
